import i18n from 'i18next';

import getEnrollmentStatusOptions from '../helpers/services/getEnrollmentStatusOptions';

export default ({ selectedUsersCount, enrolledUsers }) => {
  const baseProperties = {
    due_on: {
      type: 'Date',
      label: i18n.t('due-date'),
      placeholder: i18n.t('select-date'),
      ...(selectedUsersCount === 1 && {
        validators: [{ type: 'isRequired' }],
      }),
    },
    status: {
      type: 'Select',
      label: i18n.t('status'),
      selectProps: {
        isFullWidth: true,
        menuPortalTarget: document.body,
      },
      options: getEnrollmentStatusOptions({ enrolledUsers }),
      ...(selectedUsersCount === 1 && {
        validators: [{ type: 'isRequired' }],
      }),
    },
    relationship_type: {
      type: 'Select',
      label: i18n.t('type'),
      selectProps: {
        isFullWidth: true,
        menuPortalTarget: document.body,
      },
      options: [
        { label: i18n.t('required'), value: 'required' },
        { label: i18n.t('recommended'), value: 'recommended' },
        { label: i18n.t('elected'), value: 'elected' },
        { label: i18n.t('instructor'), value: 'instructor' },
      ],
      ...(selectedUsersCount === 1 && {
        validators: [{ type: 'isRequired' }],
      }),
    },
  };

  const additionalProperties = {};

  if (selectedUsersCount === 1) {
    additionalProperties.recommended_by = {
      type: 'Text',
      label: i18n.t('recommended-by'),
    };
    additionalProperties.relationship_reason = {
      type: 'TextArea',
      label: i18n.t('reason'),
    };
  }

  additionalProperties.completed_on = {
    type: 'Date',
    label: i18n.t('completed-date'),
    placeholder: i18n.t('select-date'),
    validators: [{ type: 'isRequiredIfVisible' }],
    conditions: [{ type: 'isStatusInProgressOrAssessmentCompleted', shouldHideField: true }],
  };

  additionalProperties.score = {
    type: 'Number',
    label: i18n.t('score'),
    conditions: [
      { type: 'isStatusInProgressOrAssessmentCompleted', shouldHideField: true },
      { type: 'isStatusNoShow', shouldHideField: true },
      { type: 'isStatusIncomplete', shouldHideField: true },
      { type: 'isStatusDropped', shouldHideField: true },
    ],
  };

  additionalProperties.expires_on = {
    type: 'Date',
    label: i18n.t('expires-date'),
    placeholder: i18n.t('select-date'),
    conditions: [
      { type: 'isStatusInProgressOrAssessmentCompleted', shouldHideField: true },
      { type: 'isStatusFailed', shouldHideField: true },
      { type: 'isStatusNoShow', shouldHideField: true },
      { type: 'isStatusIncomplete', shouldHideField: true },
      { type: 'isStatusDropped', shouldHideField: true },
    ],
  };

  return {
    ...baseProperties,
    ...additionalProperties,
  };
};
